import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { r } from '../../../shared/lib/responsive';

export const Header = styled.header`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${r('height', 54)}
  padding: var(--header-padding-y) var(--header-padding-x);
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${r('width', 28)}
  ${r('height', 28)}
  padding: 0;
  border: none;
  background: transparent;

  &:focus-visible {
    outline: 2px solid var(--color-header-icon);
    ${r('outline-offset', 2)}
    ${r('border-radius', 6)}
  }

  &:hover {
    opacity: 0.85;
  }
`;

export const BackIcon = styled.svg`
  display: block;
  ${r('width', 28)}
  ${r('height', 28)}
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--header-action-gap);
`;

export const IconButton = styled.button<{ $white?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-header-action-icon);

  &:focus-visible {
    outline: 2px solid var(--color-header-action-icon);
    ${r('outline-offset', 2)}
    ${r('border-radius', 6)}
  }

  &:hover {
    opacity: 0.8;
  }

  ${(p) =>
    p.$white &&
    css`
      color: var(--color-header-icon);

      &:focus-visible {
        outline-color: var(--color-header-icon);
      }
    `}
`;

export const IconGlobe = styled.svg`
  display: block;
  ${r('width', 19)}
  ${r('height', 19)}
`;

export const IconShare = styled.svg`
  display: block;
  ${r('width', 16)}
  ${r('height', 17)}
`;

export const IconClose = styled.svg`
  display: block;
  ${r('width', 15)}
  ${r('height', 15)}
`;
